import { ModuleWithProviders, NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'

import { DraggableDirective } from './draggable.directive'
import { DragService } from './drag.service'
import { DropTargetDirective } from './drop-target.directive'

@NgModule({
  imports: [
    CommonModule,
  ],
  declarations: [
    DraggableDirective,
    DropTargetDirective,
  ],
  exports: [
    DraggableDirective,
    DropTargetDirective,
  ]
})
export class DndModule {
  static forRoot(): ModuleWithProviders {
    return {
      ngModule: DndModule,
      providers: [
        DragService,
      ]
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/dnd/dnd.module.ts